
  import Vue from "vue";

  export default Vue.extend({
    name: "pwa-download-app-banner",
    computed: {
      iosAppUrl(): string {
        return process.env.VUE_APP_IOS_APP_URL;
      },
      androidAppUrl(): string {
        return process.env.VUE_APP_ANDROID_APP_URL;
      },
    }
  });
